import React from 'react';

import BRLMoneyFormat from '../../../../../../../utils/BRLMoneyFormat';

import { ComplementoRowWrapper } from '../../../drawer_styles';

interface ComplementoRowProps {
  descricao: string;
  preco: string;
}

const ComplementoRow: React.FC<ComplementoRowProps> = ({
  descricao,
  preco,
}: ComplementoRowProps) => {
  return (
    <ComplementoRowWrapper>
      <div>
        <span className="nome_complemento">{descricao}</span>
        <span className="preco_complemento">
          {Number(preco).toLocaleString('pt-BR', BRLMoneyFormat)}
        </span>
      </div>
    </ComplementoRowWrapper>
  );
};

export default ComplementoRow;
